<div class="card empty" *ngIf="!published; else ready">
  Publish the document pack first to enable source-presentation transformation.<br>
  <button type="button" class="link go-publish" (click)="goPublish()">Go to publish</button>
</div>

<ng-template #ready>
  <div class="deck-grid">
    <section class="card pad deck-card">
      <label class="lbl" for="deck-add">Add an item for the workshop (optional)</label>
      <div class="add">
        <input id="deck-add" class="fld" [(ngModel)]="newItem" name="deckAdd" placeholder="e.g. Walk through bio-refinery order type" (keydown.enter)="addItem(); $event.preventDefault()">
        <button type="button" class="btn add-btn" (click)="addItem()"><df-icon name="plus" [size]="14"></df-icon>Add</button>
      </div>

      <div class="row-actions">
        <button type="button" class="btn pri gen-btn" [disabled]="deck.busy" (click)="generate()">
          <df-icon name="spark" [size]="15"></df-icon>{{ deck.busy ? 'Generating…' : deck.result ? 'Regenerate PPT' : 'Generate PPT' }}
        </button>
      </div>

      <div class="pills" *ngIf="extras.length"><span class="pill" *ngFor="let e of extras">{{ e }}</span></div>
      <p class="deck-error" role="alert" *ngIf="error">{{ error }}</p>
    </section>

    <section class="card deck-prev">
      <div class="stream-h">
        <b>{{ deck.result ? 'Workshop deck ready' : 'Generated deck' }}</b>
        <span class="acts" *ngIf="deck.result">
          <button type="button" class="btn sm pri dl-btn" (click)="download()"><df-icon name="dl" [size]="14"></df-icon>Download .pptx</button>
        </span>
      </div>
      <div class="empty" *ngIf="deck.result; else noDeck">
        <p>AI-generated content may be incorrect. Please review the deck carefully before use.</p>
      </div>
      <ng-template #noDeck>
        <div class="empty">{{ deck.busy ? 'Transforming the source presentation using the Chevron design template…' : 'Generate to transform the source presentation into the designed PowerPoint.' }}</div>
      </ng-template>
    </section>
  </div>
</ng-template>

<div class="step-nav" style="display:flex;margin-top:18px">
  <button type="button" class="btn back-btn" (click)="goBack()">Back</button>
</div>
